/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Alert, Heading, HFlow, VFlow } from 'bold-ui'
import { AcompanhamentoCondicaoSaudeTematicaEnum } from 'graphql/types.generated'
import { ReactComponent as IconSaudeMulher } from 'images/acompanhamento/icon-saude-mulher.svg'
import { Meta } from 'util/metaPath'

import { ListaTematicaRadioButton } from './ListaTematicaRadioButton'

interface ListaTematicaSectionProps {
  name: Meta<AcompanhamentoCondicaoSaudeTematicaEnum>
  handleChangeListaTematica: (listaTematica: AcompanhamentoCondicaoSaudeTematicaEnum) => void
}

export const ListaTematicaSection = (props: ListaTematicaSectionProps) => {
  const { name, handleChangeListaTematica } = props

  return (
    <VFlow vSpacing={0.5}>
      <Heading level={2}>Lista Temática</Heading>
      <Alert type='info' inline>
        As listas temáticas apresentam resultados específicos para cada condição e utilizam apenas dados PEC (exceto a
        lista geral).
      </Alert>
      <HFlow hSpacing={0.5} style={styles.hFlow}>
        <ListaTematicaRadioButton
          name={name}
          label='Geral'
          value={AcompanhamentoCondicaoSaudeTematicaEnum.GERAL}
          onClick={handleChangeListaTematica}
          icon='userFilled'
        />
        <ListaTematicaRadioButton
          name={name}
          label='Gestação e puerpério'
          value={AcompanhamentoCondicaoSaudeTematicaEnum.GESTANTE_PUERPERA}
          onClick={handleChangeListaTematica}
          icon='pregnant'
        />
        <ListaTematicaRadioButton
          name={name}
          label='Pessoa idosa'
          value={AcompanhamentoCondicaoSaudeTematicaEnum.PESSOA_IDOSA}
          onClick={handleChangeListaTematica}
          icon='sixtyPlus'
        />
        <ListaTematicaRadioButton
          name={name}
          label='Desenvolvimento infantil'
          value={AcompanhamentoCondicaoSaudeTematicaEnum.DESENVOLVIMENTO_INFANTIL}
          onClick={handleChangeListaTematica}
          icon='teddyBear'
        />
        <ListaTematicaRadioButton
          name={name}
          label='Diabetes'
          value={AcompanhamentoCondicaoSaudeTematicaEnum.DIABETES}
          onClick={handleChangeListaTematica}
          icon='glucometer'
        />
        <ListaTematicaRadioButton
          name={name}
          label='Hipertensão'
          value={AcompanhamentoCondicaoSaudeTematicaEnum.HIPERTENSAO_ARTERIAL}
          onClick={handleChangeListaTematica}
          icon='bloodPressureFilled'
        />
        <ListaTematicaRadioButton
          name={name}
          label='Saúde da mulher'
          value={AcompanhamentoCondicaoSaudeTematicaEnum.SAUDE_MULHER}
          onClick={handleChangeListaTematica}
          icon={IconSaudeMulher}
        />
        <ListaTematicaRadioButton
          name={name}
          label='Saúde bucal'
          value={AcompanhamentoCondicaoSaudeTematicaEnum.SAUDE_BUCAL}
          onClick={handleChangeListaTematica}
          icon='toothFilled'
        />
      </HFlow>
    </VFlow>
  )
}

const styles = {
  hFlow: css`
    display: flex;
    flex-wrap: wrap;
    align-items: start;
  `,
}
